import type { SourcingEventV2Dto } from "../../../../autogen/bff-api";
import { allowsNegotiation } from "../../../sourcing-events/buyer/wizard/utils/procedure";

/**
 * Mirrors NegotiationRoundV2Service.roundsAllowed in the BFF. Private competitions may always
 * negotiate; a public one may only where the procedure allows it (FOA § 23-6), and only once the
 * participants are settled — for two-stage procedures that is the § 23-2 invitation.
 */
export const supportsNegotiationRounds = (event: SourcingEventV2Dto): boolean => {
  if (event.eventContext.type === "Private") return true;
  if (event.eventContext.type !== "Public") return false;
  if (!allowsNegotiation(event.eventContext.procedureType)) return false;
  return event.eventContext.qualificationRound?.invitation != null;
};
